import { render, staticRenderFns } from "./DataFragment.vue?vue&type=template&id=37f04e6b"
import script from "./DataFragment.vue?vue&type=script&lang=js"
export * from "./DataFragment.vue?vue&type=script&lang=js"
import style0 from "./DataFragment.vue?vue&type=style&index=0&id=37f04e6b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports